import {Injectable} from '@angular/core';
import {HttpService} from './http.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs/Observable';
import {GetSitePageResponseDto} from '../models/GetSitePageResponseDto';
import {PostSitePageRequestDto} from '../models/post/PostSitePageRequestDto';
import {HttpResponse} from '@angular/common/http';
import {SitePageScoresTableRowModel} from '../models/SitePageScoresTableRowModel';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class SitePagesService {

    newlyAddedSitePageScoresReceivedSubject = new Subject<SitePageScoresTableRowModel>();
    addSitePageSuccessSubject = new Subject<GetSitePageResponseDto>();

    constructor(private httpService: HttpService) {}

    getById(id: number): Observable<HttpResponse<GetSitePageResponseDto>> {
        const url = environment.ENDPOINTS.GET_SITE_PAGE_BY_ID.replace('{:id}', id.toString());
        return this.httpService.getJson<GetSitePageResponseDto>(url);
    }

    addSitePage(sitePage: PostSitePageRequestDto): Observable<HttpResponse<GetSitePageResponseDto>> {
        const url = environment.ENDPOINTS.ADD_SITE_PAGE;
        return this.httpService.postJson<GetSitePageResponseDto>(url, sitePage);
    }

    addSitePageSuccess(sitePage: GetSitePageResponseDto) {
        this.addSitePageSuccessSubject.next(sitePage);
    }

    getAddSitePageSuccessSubject(): Observable<GetSitePageResponseDto> {
        return this.addSitePageSuccessSubject.asObservable();
    }

    getSitePageScores(sitePageId: number, scoreAccumulatorId: number, reviewDate: string): Observable<HttpResponse<SitePageScoresTableRowModel>> {
        const id = sitePageId.toString();
        const accumulatorId = scoreAccumulatorId.toString();
        const url = environment.ENDPOINTS.GET_SITE_PAGE_SCORES
            .replace('{:sitePageId}', id)
            .replace('{:scoreAccumulatorId}', accumulatorId)
            .replace('{:reviewDate}', reviewDate);
        return this.httpService.getJson<SitePageScoresTableRowModel>(url);
    }

    newlyAddedSitePageScoresReceived(sitePageScoresTableRowModel: SitePageScoresTableRowModel) {
        this.newlyAddedSitePageScoresReceivedSubject.next(sitePageScoresTableRowModel);
    }

    getNewlyAddedSitePageScoresReceivedSubject(): Observable<SitePageScoresTableRowModel> {
        return this.newlyAddedSitePageScoresReceivedSubject.asObservable();
    }
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/services/site-pages.service.ts